// Owner: record-runtime. The record page of every object. Below 640 px the phone record renders
// instead (record-create-mobile).
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { FilterNodeSchema } from '@dataroom/core';
import { RecordPage } from '../../../../../features/records/RecordPage';

/**
 * `?tab=` the open tab; `?filter=` the list the member came from (a FilterNode: position and
 * previous / next follow it — lists link records with their current filter).
 */
const Search = z.object({
  tab: z
    .string()
    .max(64)
    .regex(/^[a-zA-Z0-9_-]+$/)
    .optional()
    .catch(undefined),
  filter: FilterNodeSchema.optional().catch(undefined),
});

export const Route = createFileRoute('/_app/o/$object/r/$recordId')({
  validateSearch: Search,
  component: RecordRoute,
});

function RecordRoute() {
  const { object, recordId } = Route.useParams();
  const { tab, filter } = Route.useSearch();
  return (
    <RecordPage
      key={`${object}:${recordId}`}
      objectKey={object}
      recordId={recordId}
      tab={tab ?? null}
      filter={filter ?? null}
    />
  );
}
